import React, { useEffect } from "react";
import Image from "../Assets/img/misc/Coming soon.jpg";
import sailor from "../Assets/img/Sailor.png";
import styles from "../Assets/css/comingsoon.module.css";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

function ComingSoon() {
	useEffect(() => {
		// check if user is logged in
		console.log("coming soon");
		const token = localStorage.getItem("token");
		if (token) {
			window.location.href = "/superAdmin";
		} else {
			window.location.href = "/signin";
		}
	}, []);

	return (
		<>
			<Navbar />
			{/* <div className={styles.bg}>
        <img src={Image} alt="" />
      </div> */}
			<div className={styles.body}>
				<div className={`container ${styles.page_not_found_div}`}>
					{/* <div> */}
					<div>
						{/* <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12"> */}
						<div>
							{" "}
							<img src={sailor} alt="" className="img-fluid" />
							<h1 className={styles.error_text_bold}>Oops!</h1>
							<h1 className={styles.error_text}>
								Error 404 - Page Not Found
							</h1>
							<h2 className={styles.error_text_h2}>
								The page you requested could not be found{" "}
							</h2>
							<h2 className={styles.error_text_h2}>
								{" "}
								We will take you back&nbsp;
								<a className={styles.anchor} href="/">
									{" "}
									Home
								</a>{" "}
								:){" "}
							</h2>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
export default ComingSoon;
